import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS, CHART_COLORS_THREE, CHART_COLORS_TWO, CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function ClusteredAmChart(props) {
  const [viewData, setViewData] = useState([]);
  const { outletper } = props;
  useEffect(() => {
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          category: "Not Available",
          first: 0,
          second: 0,
          third: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        for (let index = 0; index < clinic.length; index++) {
          if((index + 1) > CHART_MAX_VALUES) {
            break;
          }
          const details = {
            category: clinic[index].OutletName,
            first: clinic[index].TotalAchievedPercentage,
            second: clinic[index].TotalTarget,
            third: clinic[index].TotalSales,
          };
          viewDetail.push(details);
        }

        setViewData(viewDetail);
      }
    }
  }, [outletper]);

  useLayoutEffect(() => {
    // const chart = am4core.create('chartdiv8', am4charts.XYChart);
    var chart = am4core.create('chartdiv8', am4charts.XYChart)
    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarY = new am4core.Scrollbar();
    chart.colors.step = 2;

    chart.legend = new am4charts.Legend()
    chart.legend.position = 'top'
    chart.legend.paddingBottom = 20
    chart.legend.labels.template.maxWidth = 125

    var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
    xAxis.dataFields.category = 'category'
    xAxis.renderer.cellStartLocation = 0.1
    xAxis.renderer.cellEndLocation = 0.9
    xAxis.renderer.grid.template.location = 0;

    xAxis.renderer.cellStartLocation = 0.1;
    xAxis.renderer.cellEndLocation = 0.9;

    xAxis.tooltip.disabled = true;

    var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = 0;
    yAxis.cursorTooltipEnabled = true;
    
    let paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    paretoValueAxis.renderer.opposite = true;
    paretoValueAxis.min = 0;
    // paretoValueAxis.max = 100;
    paretoValueAxis.strictMinMax = true;
    paretoValueAxis.renderer.grid.template.disabled = true;
    paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
    paretoValueAxis.numberFormatter.numberFormat = "#'%'";
    paretoValueAxis.cursorTooltipEnabled = true;

    let paretoSeries = chart.series.push(new am4charts.LineSeries());
    paretoSeries.dataFields.valueY = "achievement";
    paretoSeries.dataFields.categoryX = "category";
    paretoSeries.yAxis = paretoValueAxis;
    paretoSeries.tooltipText = "Achievement: {valueY.formatNumber('#.0')}%[/]";
    paretoSeries.bullets.push(new am4charts.CircleBullet());
    paretoSeries.strokeWidth = 2;
    paretoSeries.stroke = new am4core.InterfaceColorSet().getFor(
      "alternativeBackground"
    );
    paretoSeries.strokeOpacity = 0.5;

    function createSeries(value, name) {
      var series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = value
      series.dataFields.categoryX = 'category'
      series.name = name
      series.columns.template.width = am4core.percent(100);
      series.tooltipText = "[{categoryX}: bold]{valueX}[/]";
      series.events.on("hidden", arrangeColumns);
      series.events.on("shown", arrangeColumns);

      var bullet = series.bullets.push(new am4charts.LabelBullet())
      bullet.interactionsEnabled = false
      bullet.dy = 30;
      bullet.label.text = '{valueX}'
      bullet.label.fill = am4core.color('#ffffff')

      return series;
    }



    const viewData = [
      {
        category: "Outlet 11",
        hbb: 233,
        hayyak: 244,
        baqati: 344,
        upgrade: 344,
        achievement: 100,
      },
      {
        category: "Outlet 2",
        hbb: 333,
        hayyak: 121,
        baqati: 453,
        upgrade: 123,
        achievement: 88,
      },
      {
        category: "Outlet 3",
        hbb: 654,
        hayyak: 231,
        baqati: 534,
        upgrade: 324,
        achievement: 98,
      },
      {
        category: "Outlet 4",
        hbb: 442,
        hayyak: 124,
        baqati: 764,
        upgrade: 322,
        achievement: 90,
      },
      {
        category: "Outlet 5",
        hbb: 123,
        hayyak: 234,
        baqati: 654,
        upgrade: 344,
        achievement: 88,
      },
      {
        category: "Outlet 6",
        hbb: 222,
        hayyak: 434,
        baqati: 343,
        upgrade: 353,
        achievement: 33,
      },
      {
        category: "Outlet 7",
        hbb: 424,
        hayyak: 111,
        baqati: 333,
        upgrade: 444,
        achievement: 44,
      },
      {
        category: "Outlet 8",
        hbb: 543,
        hayyak: 344,
        baqati: 644,
        upgrade: 133,
        achievement: 88,
      },
    ]


    chart.data = viewData

      // Modify chart's colors
      chart.colors.list = [
        am4core.color("#0063a4"),
        am4core.color("#f89d21").lighten(0.5),
        am4core.color("#f89d21"),
        am4core.color("#0063a4").lighten(0.5),
      ];

    createSeries('hbb', 'HBB');
    createSeries('hayyak', 'Hayyak');
    createSeries('baqati', 'Baqati');
    createSeries('upgrade', 'Upgrade');

    function arrangeColumns() {

      var series = chart.series.getIndex(0);

      var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
      if (series.dataItems.length > 1) {
        var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
        var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
        var delta = ((x1 - x0) / chart.series.length) * w;
        if (am4core.isNumber(delta)) {
          var middle = chart.series.length / 2;

          var newIndex = 0;
          chart.series.each(function (series) {
            if (!series.isHidden && !series.isHiding) {
              series.dummyData = newIndex;
              newIndex++;
            }
            else {
              series.dummyData = chart.series.indexOf(series);
            }
          })
          var visibleCount = newIndex;
          var newMiddle = visibleCount / 2;

          chart.series.each(function (series) {
            var trueIndex = chart.series.indexOf(series);
            var newIndex = series.dummyData;

            var dx = (newIndex - trueIndex + middle - newMiddle) * delta

            series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
            series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
          })
        }
      }
    }


    // chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv8" style={{ width: '100%', height: '500px', direction: "ltr" }} />;
}
